import { combineReducers } from 'redux';
import {
  SET_UNION_CATEGORIES,
  SET_UNION_ITEM_VARIANTS,
  SET_UNION_ITEMS,
} from 'actions/customers/loyalty/constants';
import createReducer from 'utils/createReducer';

const categories = createReducer([], {
  [SET_UNION_CATEGORIES]: (draft, { payload }) => payload.categories,
});

const items = createReducer([], {
  [SET_UNION_ITEMS]: (draft, { payload }) => payload.items,
});

const itemVariants = createReducer(
  {},
  {
    [SET_UNION_ITEM_VARIANTS]: (draft, { payload }) => {
      const { itemName, itemVariants } = payload;
      draft[itemName] = itemVariants;
    },
  }
);

export default combineReducers({
  categories,
  items,
  itemVariants,
});
